import { width } from '@mui/system';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../css/Accounts.css';
import Button from '@mui/material/Button';
import Modal from 'react-modal';
import MainWrapper from '../wrappers/mainWrapper';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { useNavigate } from 'react-router-dom';
import levlrLogo from '../../img/LEVLR Logo_CMYK.png'
import { logoEvent } from '../navigation/events';
import StripeContext from './stripeContext.jsx';
import SavedPaymentMethods from './savedPaymentMethods.jsx';
import CheckoutForm from './checkoutForm.jsx';
import SubscriptionForm from './subscriptionForm.jsx';
import fallbackLogo from '../../img/default-logo.png';
import "../../css/App.css";

const Accounts = props => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    const [customerId, setCustomerId] = useState("");
    let getUserId = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [hasSavedPaymentMethod, setHasSavedPaymentMethod] = useState(false);
    const [openCompany, setOpenCompany] = useState(false)
    const [openACCType, setOpenACCType] = useState(false)
    const [openPhoneNumber, setOpenPhoneNumber] = useState(false)
    const [companyInformation, setCompanyInformation] = useState({
        name: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        zipCode: ""
    })

    const handleCustomerId = (id) => {
        setCustomerId(id);
    };

    const [accType, setAccType] = useState({acc_type: ""})
    const [phoneNumber, setPhoneNumber] = useState({phone: ""})
    const [userData, setUserData] = useState()
    const [initialResponse, setInitialResponse] = useState(true)

    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);

    const [logoUrl, setLogoUrl] = useState(null);
    const [error, setError] = useState(null);
  
    const uploadUrl = process.env.REACT_APP_UPLOAD_LOGO;

    useEffect(() => {
        async function fetchLogoUrl() {
        try {
            const res = await fetch(`${process.env.REACT_APP_GET_LOGO}/${getUserId._id}`, {
            credentials: 'include', // if needed
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || 'Failed to fetch logo URL');
            setLogoUrl(data.logoUrl);
        } catch (err) {
            setError(err.message);
        }
        }

        fetchLogoUrl();
    }, [getUserId, uploading]);

    useEffect(() => {
        if (!getUserId?.email) return;
    
        const checkStripeCustomer = async () => {
          try {
            const { data } = await axios.get(
              `${process.env.REACT_APP_GET_STRIPE_CUSTOMERS}`,
              { params: { email: getUserId?.email } }
            );

            if (data.exists) {
              dispatch({
                type: "SET_STRIPE_CUSTOMER",
                payload: data.customer,
              });
              setCustomerId(data.customer?.id || "");
            } else {
              dispatch({
                type: "SET_STRIPE_CUSTOMER",
                payload: null,
              });
            }
          } catch (err) {
            console.error("Error checking stripe customer", err);
          }
        };
    
        // Run immediately
        checkStripeCustomer();
    
        // Poll every 60s
        const interval = setInterval(checkStripeCustomer, 7000);
        
        return () => clearInterval(interval);
      }, [getUserId.email, customerId, dispatch]);

    /* if (error) return <p style={{ color: 'red' }}>{error}</p>;
    if (!logoUrl) return <p>Loading logo...</p>; */

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        setError(null);
      
        if (selectedFile) {
          const objectUrl = URL.createObjectURL(selectedFile);
          setPreviewUrl(objectUrl);
        } else {
          setPreviewUrl(null);
        }
      };
      
  
      const handleUpload = async () => {
        if (!file) {
          setError('Please select a file first');
          return;
        }
      
        setUploading(true);
      
        const formData = new FormData();
        formData.append('logo', file);
        formData.append('userId', getUserId._id);
      
        try {
          const res = await fetch(uploadUrl, {
            method: 'POST',
            credentials: 'include',
            body: formData,
          });
      
          const data = await res.json();
      
          if (!res.ok) {
            throw new Error(data.error || 'Upload failed');
          }
      
          // Set uploaded logo URL from server response
          setLogoUrl(data.logoUrl); 
          setPreviewUrl(null); // optional: clear preview
          setFile(null);
      
          // Dispatch event so other components can refresh logo
          logoEvent.dispatchEvent(new Event('refreshLogo'));
      
        } catch (err) {
          setError(err.message);
        } finally {
          setUploading(false);
        }
      };
      
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1200);
        if(initialResponse){
            getUser(getUserId._id)
            setInitialResponse(false)
        }
      
        if(!initialResponse && userData?.company !== undefined) {
            setPhoneNumber({phone: userData.phone})
            setAccType({acc_type: userData.acc_type})
            setCompanyInformation({name: userData?.company.name, address_1: userData?.company.address_1, address_2: userData?.company.address_2, city: userData?.company?.city, state: userData?.company?.state, zipCode: userData?.company?.zipCode})
        }

       
      }, [userData, customerId])

    const getUser = async (id) => {
    const response = await fetch(
        `${process.env.REACT_APP_GET_USER_DATA}${id}`
    ).then((response) => response.json({}));
    setUserData(response)
    }
    
    function handleSaveCompany(id) {
        setOpenCompany(false)
        axios.put(`${process.env.REACT_APP_SAVE_COMPANY}${id}`, companyInformation)
          .then(response => {   
            getUser(getUserId._id)
          })
          .catch(error => {
            alert("Saving was unsuccessful. Please try again.");
            console.error('There was an error!', error);
          });
    }

    function handleSavePhoneNumber(id) {
        setOpenPhoneNumber(false)
        axios.put(`${process.env.REACT_APP_SAVE_PHONE_NUMBER}${id}`, phoneNumber)
          .then(response => {   
            getUser(getUserId._id)
          })
          .catch(error => {
            alert("Saving was unsuccessful. Please try again.");
            console.error('There was an error!', error);
          });
    }

    function handleSaveACCType(id) {
        setOpenACCType(false)
        axios.put(`${process.env.REACT_APP_SAVE_ACC_TYPE}${id}`, accType)
          .then(response => {   
            getUser(getUserId._id)
          })
          .catch(error => {
            alert("Saving was unsuccessful. Please try again.");
            console.error('There was an error!', error);
          });
    }

    function returnVal(value){
        if(value === undefined) {
            return
        }
        else {
            return(
                value
            )
        }
    }   
   

    function returnProfileContainer() {
        if(userData === undefined) {
            return(
                <div className={'profile-container'}>
                    <h1>One Moment Please.</h1>
                </div>
            )
        }
        else {
            return(
                <div className={'profile-container'}>
                    <Modal
                        ariaHideApp={false}
                        style={modalRestyleSmall}
                        isOpen={openACCType}
                        onRequestClose={() => setOpenACCType(false)}
                    >

                        <div style={modalStyle}>
                            <h1>Edit Account Type</h1>
                        </div>

                        <div style={centerFields}>
                            <FormControl variant="outlined" margin="normal" size="small" style={textFieldStyle}>
                                <InputLabel id="acc_type-label">Account Type</InputLabel>
                                <Select
                                    labelId="acc_type-label"
                                    id="acc_type"
                                    name="acc_type"
                                    defaultValue={returnVal(userData.acc_type)}
                                    onBlur={(e) => setAccType({acc_type: e.target.value.trim()})}                                    
                                    label="Account Type"
                                >
                                    <MenuItem value="Contractor">Contractor</MenuItem>
                                    <MenuItem value="Adjuster">Adjuster</MenuItem>
                                </Select>
                            </FormControl>
                        </div>                    

                        <div style={buttonContainer}>
                            <Button
                                size="small"
                                sx={{
                                ':hover': {
                                    backgroundColor: '#999999'
                                },
                                margin: '8px 8px', 
                                fontWeight: 'bold', 
                                color: 'white', 
                                backgroundColor: '#723E49'}}
                                onClick={() => setOpenACCType(false)}
                            >
                                Exit
                            </Button>
                            <Button
                                size="small"
                                sx={{
                                ':hover': {
                                    backgroundColor: '#999999'
                                },
                                margin: '8px 8px', 
                                fontWeight: 'bold', 
                                color: 'white', 
                                backgroundColor: '#00B3B5'}}
                                onClick={() => handleSaveACCType(userData._id)}
                            >
                                Save
                            </Button>
                        </div>    

                    </Modal>

                    <Modal
                        ariaHideApp={false}
                        style={modalRestyleLarge}
                        isOpen={openCompany}
                        onRequestClose={() => setOpenCompany(false)}
                    > 

                        <div style={modalStyle}>
                            <h1>Edit Company Information</h1>
                        </div>

                        <div style={centerFields}>
                            <TextField
                                style={textFieldStyle}
                                label={"Company Name"}
                                defaultValue={returnVal(userData.company?.name)}
                                onBlur={(e) => setCompanyInformation({...companyInformation, name: e.target.value.trim()})}
                            />
                            <TextField
                                style={textFieldStyle}
                                label={"Address Line 1"}
                                defaultValue={returnVal(userData.company?.address_1)}
                                onBlur={(e) => setCompanyInformation({...companyInformation, address_1: e.target.value.trim()})}
                            />
                            <TextField
                                style={textFieldStyle}
                                label={"Address Line 2"}
                                defaultValue={returnVal(userData.company?.address_2)}
                                onBlur={(e) => setCompanyInformation({...companyInformation, address_2: e.target.value.trim()})}
                            />
                            <TextField
                                style={textFieldStyle}
                                label={"City"}
                                defaultValue={returnVal(userData.company?.city)}
                                onBlur={(e) => setCompanyInformation({...companyInformation, city: e.target.value.trim()})}
                            />
                            <TextField
                                style={textFieldStyle}
                                label={"State"}
                                defaultValue={returnVal(userData.company?.state)}
                                onBlur={(e) => setCompanyInformation({...companyInformation, state: e.target.value.trim()})}
                            />
                            <TextField
                                style={textFieldStyle}
                                label={"Zip Code"}
                                defaultValue={returnVal(userData.company?.zipCode)}
                                onBlur={(e) => setCompanyInformation({...companyInformation, zipCode: e.target.value.trim()})}
                            />
                        </div>

                        <div style={buttonContainer}>
                            <Button
                                size="small"
                                sx={{
                                ':hover': {
                                    backgroundColor: '#999999'
                                },
                                fontWeight: 'bold', 
                                color: 'white',
                                margin: '8px 8px',
                                backgroundColor: '#723E49'}}
                                onClick={() => setOpenCompany(false)}
                            >
                                Exit
                            </Button>
                            <Button
                                size="small"
                                sx={{
                                ':hover': {
                                    backgroundColor: '#999999'
                                },
                                fontWeight: 'bold',
                                margin: '8px 8px',
                                color: 'white', 
                                backgroundColor: '#00B3B5'}}
                                onClick={() => handleSaveCompany(userData._id)}
                            >
                                Save
                            </Button>
                        </div>
                        

                    </Modal>
                    
                    <Modal
                        ariaHideApp={false}
                        style={modalRestyleSmall}
                        isOpen={openPhoneNumber}
                        onRequestClose={() => setOpenPhoneNumber(false)}
                    >

                        <div style={modalStyle}>
                            <h1>Edit Phone Number</h1>
                        </div>
                        
                        <div style={centerFields}>
                            <TextField
                                style={textFieldStyle}
                                label={"Phone Number"}
                                defaultValue={returnVal(userData.phone)}
                                onBlur={(e) => setPhoneNumber({phone: e.target.value.trim()})}
                            />
                        </div>

                        <div style={buttonContainer}>
                            <Button
                                size="small"
                                sx={{
                                ':hover': {
                                    backgroundColor: '#999999'
                                },
                                margin: '8px 8px',
                                fontWeight: 'bold', 
                                color: 'white', 
                                backgroundColor: '#723E49'}}
                                onClick={() => setOpenPhoneNumber(false)}
                            >
                                Exit
                            </Button>

                            <Button
                                size="small"
                                sx={{
                                ':hover': {
                                    backgroundColor: '#999999'
                                },
                                fontWeight: 'bold',
                                margin: '8px 8px',
                                color: 'white', 
                                backgroundColor: '#00B3B5'}}
                                onClick={() => handleSavePhoneNumber(userData._id)}
                            >
                                Save
                            </Button>
                        </div>
                    
                    </Modal>
                    <div className={'account-details'}>
                        <div
                            style={{width: '40%'}}
                        >
                            <div>
                                <h2 className={'green-large-bold'}>ACCOUNT DETAILS</h2>
                                <h1 className={'h1-style'}>{returnVal(userData?.name) + " " + userData?.lastName}</h1>
                                <p className={'black-small'}>{returnVal(userData?.email)}</p>
                            </div>
                            
                            <div style={{marginTop: '12px'}}>
                                <h2 className={'green-small-bold'}>COMPANY</h2>
                                <Button
                                        style={editButton}
                                        size="small"
                                        onClick={()=> setOpenCompany(true)}
                                    >
                                        Edit
                                </Button>
                                <p className={'black-small-bold'}>{returnVal(userData.company?.name)}</p>
                                <p className={'black-small'}>
                                    {returnVal(userData.company?.address_1)} 
                                </p>
                                <p className={'black-small'}>
                                    {returnVal(userData.company?.address_2)} 
                                </p>
                                <p className={'black-small'}>
                                    {returnVal(userData.company?.city)} {returnVal(userData.company?.state)} &nbsp; {returnVal(userData.company?.zipCode)}
                                </p>
                            </div>
                            <div style={{marginTop: '12px'}}>
                                <h2 className={'green-small-bold'}>ACCOUNT TYPE</h2>
                                    <Button
                                        style={editButton}
                                        size="small"
                                        onClick={() => setOpenACCType(true)}
                                    >
                                        Edit
                                    </Button>
                                <p className={'black-small-bold'}>
                                    {userData.acc_type}
                                    
                                </p>
                            </div>

                            <div style={{marginTop: '12px'}}>
                                <h2 className={'green-small-bold'}>PHONE NUMBER</h2>
                                    <Button
                                        style={editButton}
                                        size="small"
                                        onClick={() => setOpenPhoneNumber(true)}
                                    >
                                        Edit
                                    </Button>
                                <p className={'black-small-bold'}>
                                    {returnVal(userData.phone)}
                                </p>
                            </div>
                            <div
                                style={{
                                    marginTop: '16px',
                                    padding: '16px',
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    backgroundColor: '#f9f9f9',
                                    maxWidth: '320px',
                                }}
                                >
                                <h3 style={{ color: '#00B3B5', marginBottom: '12px' }}>Upload Your Logo</h3>

                                {/* Custom File Input */}
                                <label
                                    htmlFor="logo-upload"
                                    style={{
                                    display: 'inline-block',
                                    padding: '8px 16px',
                                    backgroundColor: '#00B3B5',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    }}
                                >
                                    Choose File
                                </label>
                                <input
                                    id="logo-upload"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />

                                {/* Upload Button */}
                                <button
                                    onClick={handleUpload}
                                    disabled={uploading || !file}
                                    style={{
                                    padding: '8px 16px',
                                    backgroundColor: uploading || !file ? '#ccc' : '#00B3B5',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: uploading || !file ? 'not-allowed' : 'pointer',
                                    marginLeft: '8px',
                                    fontSize: '14px',
                                    }}
                                >
                                    {uploading ? 'Uploading...' : 'Upload Logo'}
                                </button>

                                {/* Error Message */}
                                {error && (
                                    <p style={{ color: 'red', marginTop: '8px', fontSize: '13px' }}>{error}</p>
                                )}

                                {/* Preview Before Upload */}
                                {previewUrl && (
                                    <div style={{ marginTop: '12px' }}>
                                    <p style={{ fontSize: '14px', marginBottom: '4px' }}>Preview:</p>
                                    <img
                                        src={previewUrl}
                                        alt="Preview Logo"
                                        style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '4px' }}
                                    />
                                    </div>
                                )}

                                {/* Uploaded Logo */}
                                {logoUrl && (
                                    <div style={{ marginTop: '12px' }}>
                                        <p style={{ fontSize: '14px', marginBottom: '4px' }}>Uploaded Logo:</p>
                                        <img
                                            src={logoUrl || fallbackLogo}
                                            onError={(e) => { e.currentTarget.src = fallbackLogo }}
                                            className="elkmont-logo-resize"
                                            alt="User Logo"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        <div
                            style={{
                                width: '60%',
                                height: '70%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}
                            >
                            <StripeContext>
                                <div class={customerId ? "previous-step" : ""}>
                                    {customerId && (
                                        <SavedPaymentMethods
                                        customerId={customerId}
                                        onCheckSaved={(exists) => setHasSavedPaymentMethod(exists)}
                                        />
                                    )}
                                    <CheckoutForm
                                        onCustomerId={handleCustomerId}
                                        existingCustomerId={handleCustomerId}
                                        hasSavedPaymentMethod={hasSavedPaymentMethod}
                                        onCardValid={(valid) => setIsCardValid(valid)}
                                    />
                                </div>
                                <SubscriptionForm customerId={customerId} hasSavedPaymentMethod={hasSavedPaymentMethod} />
                            </StripeContext>
                        </div>
                    </div>
                    <div className={'cancel-subscription'}></div>         
                </div>
            )
        }
    }

    const editButton = {
        color: 'blue',
        fontSize: '10px'
    }

    const modalStyle = {
        textAlign: 'center',
        background: 'none',
        marginBottom: '12px'
    }

    const modalRestyleSmall = {
        overlay: {
            top: '25%',
            left: '25%',
            width: '50%',
            minHeight: '275px',
            height: '30%',
            position: 'fixed',
        },
        content: {
            inset: '5%',
            border: '1px solid black',
            backgroundColor: '#DDDDDD'
        }
    }

    const modalRestyleLarge = {
        overlay: {
            top: '25%',
            left: '25%',
            width: '50%',
            height: '70%',
            minHeight: '625px',
            position: 'fixed',
        },
        content: {
            inset: '5%',
            border: '1px solid black',
            backgroundColor: '#DDDDDD'
        }
    }

    const buttonContainer = {
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 4px',
        width: '94%',
        justifyContent: 'space-between',
        position: 'absolute',
        bottom: '5%',
        marginTop: '12px'
    }

    const textFieldStyle = {
        display: 'grid',
        padding: '2px',
        backgroundColor: 'white',
        margin: '12px',
        borderRadius: '4px'
    }

    const centerFields = {
        alignItems: 'middle'
    }

    const WelcomeMessage = () => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '48px',
            textAlign: 'center',
            position: 'relative'
          }}
        >
          {/* Close button */}
          <button
            onClick={() => setIsMobile(false)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#333'
            }}
            aria-label="Close"
          >
            ✕
          </button>
      
          <a href="/login">
            <img style={{ width: '300px', height: 'auto' }} src={levlrLogo} alt="LEVLR Logo" />
          </a>
          <br />
          <br />
          <br />
          <br />
      
          <h1 style={{ fontSize: '32px' }}>Welcome to LEVLR!</h1>
          <br />
          <br />
      
          <p style={{ fontSize: '20px' }}>
            Thank you for signing up! We’re excited to have you on board and can’t wait for you to experience the power of our AI-driven solution.
          </p>
          <br />
      
          <p style={{ fontSize: '20px' }}>
            For the best experience, we recommend using our platform on a desktop. We’ve also sent a welcome email – be sure to check it out!
          </p>
          <br />
      
          <p style={{ fontSize: '20px' }}>
            Let’s get to work saving you time and boosting your revenue!
          </p>
        </div>
      );
      
      return isMobile ? (
        WelcomeMessage()
      ) : (
        <div className="outer-container">
          <MainWrapper />
          <div className="right-container">{returnProfileContainer()}</div>
        </div>
      );
}

export default Accounts
